import * as i0 from '@angular/core';
import { Optional, Directive, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, DefaultValueAccessor } from '@angular/forms';
import { TUI_VALUE_ACCESSOR } from '@taiga-ui/core/tokens';

class TuiMaskAccessorDirective {
}
TuiMaskAccessorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMaskAccessorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
TuiMaskAccessorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiMaskAccessorDirective, selector: "input[tuiMaskAccessor]", providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            deps: [[new Optional(), TUI_VALUE_ACCESSOR], DefaultValueAccessor],
            multi: true,
            useFactory: (accessor, fallback) => (accessor ? accessor[0] : fallback),
        },
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMaskAccessorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[tuiMaskAccessor]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            deps: [[new Optional(), TUI_VALUE_ACCESSOR], DefaultValueAccessor],
                            multi: true,
                            useFactory: (accessor, fallback) => (accessor ? accessor[0] : fallback),
                        },
                    ],
                }]
        }] });

/**
 * @internal
 */
class TuiMaskAccessorModule {
}
TuiMaskAccessorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMaskAccessorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiMaskAccessorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMaskAccessorModule, declarations: [TuiMaskAccessorDirective], exports: [TuiMaskAccessorDirective] });
TuiMaskAccessorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMaskAccessorModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMaskAccessorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiMaskAccessorDirective],
                    exports: [TuiMaskAccessorDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiMaskAccessorDirective, TuiMaskAccessorModule };
